import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=7a21f1b0&scoped=true"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdate.vue?vue&type=style&index=0&id=7a21f1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a21f1b0",
  null
  
)

export default component.exports